import { useQuery } from '@tanstack/react-query';
import { SettingsService } from '../../features/settings/services/settings.service';
import { User } from '../../features/settings/types/settings.types';
import { UseProfileOptions } from './useProfile';

export const getUserProfileQueryKey = (userId: string, options?: UseProfileOptions) => {
  return ['user-profile', userId, options] as const;
};

export const useUserProfile = (userId: string, options?: UseProfileOptions) => {
  const {
    data: user,
    isLoading,
    error,
    refetch,
  } = useQuery<User, Error, User>({
    queryKey: getUserProfileQueryKey(userId, options),
    queryFn: () => SettingsService.getUserProfile(userId, options),
    enabled: !!userId,
    staleTime: options?.staleTime,
    refetchOnWindowFocus: options?.refetchOnWindowFocus,
  });

  return {
    profile: user?.profile,
    isLoading,
    error,
    refetch,
  };
};
